import { AppInsightsContext, AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { ReactElement } from 'react';
import { Navigate } from 'react-router';
import { reactPlugin } from './AppInsights';
import { ApplicationInsightsSettings } from '@/AppSettings';
import RoutePath from '@/Routing/RoutePath';

interface TelemetryErrorBoundaryProps {
    children: ReactElement;
}

function ErrorPageRedirect() {
    return <Navigate to={RoutePath.Error} replace />;
}

function TelemetryErrorBoundary({ children }: TelemetryErrorBoundaryProps) {
    if (ApplicationInsightsSettings.connectionString) {
        return (
            <AppInsightsErrorBoundary appInsights={reactPlugin} onError={ErrorPageRedirect}>
                <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>
            </AppInsightsErrorBoundary>
        );
    } else {
        return children;
    }
}

export default TelemetryErrorBoundary;
